module.exports = __webpack_public_path__ + "img/224.991bc3ed.jpg";